import { render } from "./SubscriptionSuccess.vue?vue&type=template&id=45577b7e"
import script from "./SubscriptionSuccess.vue?vue&type=script&lang=js"
export * from "./SubscriptionSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__